module.exports = __webpack_public_path__ + "img/green_092.7143142c.png";